import React from 'react';
import { addMonths, differenceInCalendarMonths, parseISO } from 'date-fns';
export const useMonthNavigation = (currentMonthISO, isMonthExist) => {
    const isNextMonthExists = React.useCallback(() => {
        const nextMonth = addMonths(parseISO(currentMonthISO), 1);
        return isMonthExist(nextMonth);
    }, [currentMonthISO, isMonthExist]);
    const isPrevMonthExists = React.useCallback(() => {
        return differenceInCalendarMonths(new Date(), parseISO(currentMonthISO)) !== 0;
    }, [currentMonthISO]);
    return { isNextMonthExists, isPrevMonthExists };
};
